export type LayerStatus = "Active" | "Off" | "NeedsAttention";

export function countsAsOnBelow(status: LayerStatus): boolean {
  return status !== "Off";
}

export function computeLayerStatus(
  ownToggle: boolean,
  childStatuses: LayerStatus[],
): LayerStatus {
  if (!ownToggle) {
    return childStatuses.some(countsAsOnBelow) ? "NeedsAttention" : "Off";
  }
  return childStatuses.includes("Active") &&
    !childStatuses.includes("NeedsAttention")
    ? "Active"
    : "NeedsAttention";
}

export function computeLeafStatus(ownToggle: boolean): LayerStatus {
  return ownToggle ? "Active" : "Off";
}
